import { DeleteEntityDialog } from "@/components/common/delete-entity-dialog";
import { useDeleteStaffLevel } from "@/hooks/staff/use-staff-levels";
import type { StaffLevel } from "@/types/staff/api-types/staff-level-types";

interface DeleteStaffLevelDialogProps {
  staffLevel: StaffLevel | null;
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

export function DeleteStaffLevelDialog({
  staffLevel,
  open,
  onOpenChange,
}: DeleteStaffLevelDialogProps) {
  const deleteStaffLevel = useDeleteStaffLevel();

  return (
    <DeleteEntityDialog
      entity={staffLevel}
      open={open}
      onOpenChange={onOpenChange}
      entityName="Staff Level"
      onDelete={async (id) => {
        await deleteStaffLevel.mutateAsync(id);
      }}
      isDeleting={deleteStaffLevel.isPending}
    />
  );
}
